/*
 * Kubernetes Enhanced Plugin
 */

import {
  createPlugin,
  createComponentExtension,
} from '@backstage/core-plugin-api';

/**
 * Kubernetes Enhanced Plugin
 */
export const kubernetesEnhancedPlugin = createPlugin({
  id: 'kubernetes-enhanced',
});

/**
 * Entity Kubernetes Enhanced Content
 * Use this in EntityPage to display enhanced Kubernetes information
 */
export const EntityKubernetesEnhancedContent = kubernetesEnhancedPlugin.provide(
  createComponentExtension({
    name: 'EntityKubernetesEnhancedContent',
    component: {
      lazy: () =>
        import('./components/EntityKubernetesEnhancedContent').then(
          m => m.EntityKubernetesEnhancedContent,
        ),
    },
  }),
);
